module.exports = __webpack_public_path__ + "static/superintelligence-8362ec4a8daeba49d6b895a23a4daafb.jpg";